module.exports = __webpack_public_path__ + "img/la-regular-400.86128b7.svg";